import { stringify, ParsedUrlQuery } from 'querystring';

import { SearchQueryParams } from '../types/SearchQuery';
import filterParams from '../../common/utils/filterParams';

const API_SEARCH_ROUTE = '/api/v4/search/v1/boats/search/?';

/**
 * Subset of params that are used for search results.
 * @see SearchQueryParams for full set of valid params
 */
const ALLOWED_PARAMS: (keyof SearchQueryParams)[] = [
  'bareboat',
  'capacity',
  'captained',
  'categories',
  'category_slug',
  'clat',
  'clon',
  'currency',
  'dates',
  'filters',
  'location',
  'min_price',
  'max_price',
  'nelat',
  'nelon',
  'page',
  'place_id',
  'swlat',
  'swlon',
  'page_size',
  'beta',
  'instabooks',
  'superowners',
  'sort',
];

/**
 * Returns the search url for the specified query.
 * Unrecognized params will be removed.
 * The params are ordered alphabetically.
 */
const getSearchUrl = (query: ParsedUrlQuery): string => API_SEARCH_ROUTE + stringify(
  filterParams<SearchQueryParams>({
    query,
    allowedParams: ALLOWED_PARAMS,
    arrayParams: ['categories', 'dates', 'filters'],
  }),
);

export default getSearchUrl;
